export const promoCodes = [
 {
   code: 'RUTH10',
   discount: '10%',
   type: 'Discount',
   value: 10,
   usage: '0 / 1',
   expiry: '2025-12-31',
   status: 'Active',
 },
 {
   code: 'AER10MOF',
   discount: '10%',
   type: 'Discount',
   value: 10,
   usage: '0 / 5',
   expiry: '2025-12-31',
   status: 'Active',
 },
 {
   code: 'GFT-50',
   discount: '€50.00',
   type: 'Credit',
   value: 50,
   usage: '0 / 1',
   expiry: '2025-06-30',
   status: 'Active',
 },
];


export const vouchers = [
 {
   code: 'GFT-12345',
   amount: 50.0,
   assignedTo: 'customer@example.com',
   expiry: '2025-06-30',
   status: 'Active',
 },
 {
   code: 'REFUND-987',
   amount: 15.0,
   assignedTo: 'user@clinks.com',
   expiry: '2025-03-15',
   status: 'Used',
 },
];


export const notificationHistory = [
 {
   title: 'Flash Sale!',
   message: 'Get 20% off on all drinks today only!',
   recipients: 'Customers',
   count: 154,
   sentBy: 'Admin',
   date: '2026-01-20 14:30',
 },
 {
   title: 'Driver Update',
   message: 'New safety guidelines are now available in the app.',
   recipients: 'Drivers',
   count: 45,
   sentBy: 'Manager',
   date: '2026-01-18 09:15',
 },
];
